import { render, staticRenderFns } from "./GaugeRingChart.vue?vue&type=template&id=1f2b5b2e&scoped=true"
import script from "./GaugeRingChart.vue?vue&type=script&lang=ts"
export * from "./GaugeRingChart.vue?vue&type=script&lang=ts"
import style0 from "./GaugeRingChart.vue?vue&type=style&index=0&id=1f2b5b2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b5b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2b5b2e')) {
      api.createRecord('1f2b5b2e', component.options)
    } else {
      api.reload('1f2b5b2e', component.options)
    }
    module.hot.accept("./GaugeRingChart.vue?vue&type=template&id=1f2b5b2e&scoped=true", function () {
      api.rerender('1f2b5b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/GaugeRingChart.vue"
export default component.exports